import { useEffect, useState } from "react";
import NavV3 from "../components/v3/NavV3";
import HeroV3 from "../components/v3/HeroV3";
import Manifesto from "../components/Manifesto";
import FeaturedProjects from "../components/FeaturedProjects";
import LiveProgress from "../components/LiveProgress";
import Marquee from "../components/Marquee";
import Contact from "../components/Contact";
import FooterV3 from "../components/v3/FooterV3";
import { api } from "../lib/api";

export default function HomeV3() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-v3-root" className="bg-editorial text-obsidian min-h-screen">
      <NavV3 />
      <main id="top-v3">
        <HeroV3 />
        <Manifesto />
        <FeaturedProjects projects={projects} />
        <LiveProgress projects={projects} />
        <Marquee />
        <Contact />
      </main>
      <FooterV3 />
    </div>
  );
}
